import "./src/css/style.css"
import "./node_modules/pattern.css/dist/pattern.css"

require("prismjs/themes/prism-okaidia.css")
require("prismjs/plugins/command-line/prism-command-line.css")
